import { backendUrl } from '../../../tools/env';
import { getAuthHeaders } from '../../../tools/session/clientSession';

export const apiCall = async (endpoint, options = {}) => {
  const response = await fetch(backendUrl(endpoint), {
    ...options,
    headers: getAuthHeaders({ 'Content-Type': 'application/json', ...options.headers }),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || error.message || `API call failed: ${response.status}`);
  }
  return response.json();
};

export const fetchMysteryBootstrap = async () => apiCall('/api/mystery-client/bootstrap');

export const fetchMysteryComparison = async () => apiCall('/api/mystery-client/comparison');
